import { getIconTemplate, ICON_SPINNER_THIRD } from '../lib/icons.ts';

const getSpinnerIcon = () => {
	const $icon = document.createElement('template');
	$icon.innerHTML = getIconTemplate(ICON_SPINNER_THIRD)(
		'fa-fw fa-spin',
		'position: absolute; top: calc(50% - 1em / 2); left: calc(50% - 1.25em / 2);',
	);

	return $icon.content.firstChild as ChildNode;
};

const handleClick = (event: Event) => {
	event.preventDefault();
};

const enableClickPrevent = (
	$triggers: NodeListOf<HTMLButtonElement | HTMLInputElement> | (HTMLButtonElement | HTMLInputElement)[],
) => {
	$triggers.forEach(($trigger) => {
		$trigger.removeEventListener('click', handleClick);
	});
};

const disableClickPrevent = (
	$triggers: NodeListOf<HTMLButtonElement | HTMLInputElement> | (HTMLButtonElement | HTMLInputElement)[],
) => {
	$triggers.forEach(($trigger) => {
		$trigger.addEventListener('click', handleClick);
	});
};

const showSpinner = ($triggers: NodeListOf<HTMLElement> | HTMLElement[]) => {
	$triggers.forEach(($trigger) => {
		$trigger.style.setProperty('position', 'relative');
		$trigger.appendChild(getSpinnerIcon());
	});
};

const hideSpinner = ($triggers: NodeListOf<HTMLElement> | HTMLElement[]) => {
	$triggers.forEach(($trigger) => {
		$trigger.style.removeProperty('position');
		$trigger.querySelector('.fa-spin')?.remove();
	});
};

const addDisabled = ($triggers: NodeListOf<HTMLElement> | HTMLElement[]) => {
	$triggers.forEach(($trigger) => {
		$trigger.setAttribute('disabled', '');
	});
};

const removeDisabled = ($triggers: NodeListOf<HTMLElement> | HTMLElement[]) => {
	$triggers.forEach(($trigger) => {
		$trigger.removeAttribute('disabled');
	});
};

export default function loadFormSubmit($forms: NodeListOf<HTMLFormElement>) {
	$forms.forEach(($form) => {
		let isSubmitted = false;

		const $triggers = $form.querySelectorAll<HTMLButtonElement | HTMLInputElement>('[type="submit"]');
		if (!$triggers.length) return;

		// Need to do this because of the back/forward cache
		window.addEventListener('pageshow', () => {
			enableClickPrevent($triggers);
			hideSpinner($triggers);
			removeDisabled($triggers);
		});

		$form.addEventListener('submit', (event) => {
			if (!$form.checkValidity()) return;
			if (!event.submitter) return;
			if (event.defaultPrevented) return;

			const $submitter = event.submitter;

			if (isSubmitted) {
				event.preventDefault();

				return;
			}

			isSubmitted = true;

			disableClickPrevent($triggers);
			showSpinner([$submitter]);
			setTimeout(() => addDisabled([$submitter]));
		});
	});
}
